module.exports = __webpack_public_path__ + "static/media/SplashImage.e3a9132a.png";